import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useCurrency } from 'app/modules/CurrencyProvider';
import { routes } from 'app/routes';
import { breakpoint } from 'app/theme/theme';
import { AvailableCurrency } from 'app/translations/timezones';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  ${breakpoint.up.lg`
    position: absolute;
    bottom: -7rem;
    right: 0;
  `}
`;

const CurrencyButton = styled.button<{ $isSelected: boolean }>`
  background: none;
  box-shadow: none;
  border: none;
  color: ${({ theme, $isSelected }) => ($isSelected ? '#BA4254' : theme.palette.black.primary)};
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s all;
  padding: 0.1rem 0.6rem;

  &:hover {
    color: ${({ theme }) => theme.palette.primary};
    text-decoration: underline;
  }

  ${breakpoint.up.md`
    font-size: 1.8rem;
    padding-left: 3rem;
  `}
`;

export const CurrencySelector = (): JSX.Element | null => {
  const { currency, setCurrency } = useCurrency();
  const location = useLocation();

  if (!location.pathname.includes(routes.PAYMENT) && !location.pathname.includes(routes.INVOICE_PORTAL.ROOT)) {
    return (
      <Container>
        {Object.values(AvailableCurrency).map((value) => (
          <CurrencyButton
            type="button"
            aria-label={`currency-${value}`}
            onClick={() => setCurrency(value)}
            $isSelected={currency === value}
            key={value}
          >
            {value}
          </CurrencyButton>
        ))}
      </Container>
    );
  }
  return null;
};
